import { useCallback } from 'react';
import { useEmitAPIEvent } from '@elfsight/widget-js-api';
import { type FormField, useFormSelector } from '../../contexts';
import { API_SUBMIT_EVENT_NAME } from './constants';
import { getProcessedSubmitFields } from './utils';

export const useEmitFormSubmitEvent = () => {
  const emitAPIEvent = useEmitAPIEvent();
  const { fields: derivedFields } = useFormSelector();

  return useCallback(
    (fields: FormField[]) => {
      const processedSubmitFields = getProcessedSubmitFields(
        derivedFields,
        fields
      );

      emitAPIEvent(API_SUBMIT_EVENT_NAME, [processedSubmitFields]);
    },
    [derivedFields, emitAPIEvent]
  );
};
